import React from 'react';
import { useMeter8000Data } from '../../../../features/meter/hooks/useMeter';

export interface GpsMiniPresenterProps {
  deviceId?: string;
}

// Cellule "GPS" de la liste des compteurs: affiche les coordonnees canoniques du
// compteur (latitude, longitude) ou "Non localisé" si absentes (0,0). Reutilise la
// meme requete de localisation que la colonne "Localisation" (cache react-query
// partage), donc sans appel reseau supplementaire.
export default function GpsMiniPresenter({ deviceId }: GpsMiniPresenterProps) {
  const { getMeterInfoLocalizationByMeterIdQuery } = useMeter8000Data(deviceId);

  if (getMeterInfoLocalizationByMeterIdQuery.isLoading) return <>...</>;

  const data = getMeterInfoLocalizationByMeterIdQuery.data;
  const lat = data?.lattitude ?? 0;
  const lng = data?.longitude ?? 0;
  if (!lat && !lng) return <>Non localisé</>;

  return (
    <>
      {lat.toFixed(5)}, {lng.toFixed(5)}
    </>
  );
}
